import { Table, Button, Form } from 'react-bootstrap';

import { useGetUsersQuery, useUpdateUserMutation } from '../../slices/usersApiSlice';
import Message from '../../components/Message';
import Loader from '../../components/Loader';

const AdminUsersScreen = () => {
  
  const { data: users, isLoading, error } = useGetUsersQuery();
  const [updateUser] = useUpdateUserMutation();

  const updateRoleHandler = async (userId, isStaff, isAdmin) => {
    try {
      await updateUser({ userId, isStaff, isAdmin }).unwrap();
      alert('User updated successfully');
    } catch (error) {
      alert(error?.data?.message || error.error);
    }
  };

  return (
    <>
      <h2>Manage Users</h2>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error?.data?.message || error.error}</Message>
      ) : (
        <Table striped hover responsive className='table-sm'>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Staff</th>
              <th>Admin</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user._id}>
                <td>{user._id}</td>
                <td>{user.name}</td>
                <td>{user.email}</td>
                <td>
                  <Form.Check
                    type='checkbox'
                    checked={user.isStaff}
                    onChange={() => updateRoleHandler(user._id, !user.isStaff, user.isAdmin)}
                  />
                </td>
                <td>
                  <Form.Check
                    type='checkbox'
                    checked={user.isAdmin}
                    onChange={() => updateRoleHandler(user._id, user.isStaff, !user.isAdmin)}
                  />
                </td>
                <td>
                  <Button variant='danger' onClick={() => alert('Delete User Function Here')}>
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default AdminUsersScreen;